<template>
    <div class="shouhou">
      <el-row>
        <el-col :xs="12" :sm="6">
          <div class="col-content" @mouseenter="active=1">
            <img class="shouhou-icon" :class="active==1?'shouhou-icon-hover':''" src="@/assets/home/售后1.png" alt="">
            <span class="shouhou-title">一年免费运维服务</span>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6">
          <div class="col-content" @mouseenter="active=2">
            <img class="shouhou-icon" :class="active==2?'shouhou-icon-hover':''" src="@/assets/home/售后2.png" alt="">
            <span class="shouhou-title">7*24技术在线服务</span>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6">
          <div class="col-content" @mouseenter="active=3">
            <img class="shouhou-icon" :class="active==3?'shouhou-icon-hover':''" src="@/assets/home/售后3.png" alt="">
            <span class="shouhou-title">1名专职运维服务经理</span>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6">
          <div class="col-content" @mouseenter="active=4">
            <img class="shouhou-icon" :class="active==4?'shouhou-icon-hover':''" src="@/assets/home/售后4.png" alt="">
            <span class="shouhou-title">轻松应对上线后问题</span>
          </div>
        </el-col>
      </el-row>
      <div class="beian">
         Copyright ©2024www.lnzlwlkj.com 智领未来版权所有
         <a href="https://beian.miit.gov.cn/" style="color:white;text-decoration: none;" target="_blank">辽ICP备2024046634号</a> <!--  京ICP备17033802号 -->
      </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {},
  components: {
  },
  data() {
    return {
      active:''
    };
  },
  computed: {
  },
  watch:{
    active(val){
      setTimeout(()=>{
        this.active=''
      },200)
    }
  },
  methods: {
  },
  mounted(){
  }
};
</script>

<style scoped lang="scss">
.shouhou{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  user-select:text;
}
.el-row{
  width: $public-width;
  max-width: 100%;
  margin-bottom: 30px;
  padding: 8px 0;
  border-bottom: 1px solid #999999;
  .el-col{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
    .col-content{
      display: flex;
      align-items: center;
    }
    .shouhou-icon{
      width: 40px;
      height: 40px;
      transform-style: preserve-3d;
      transition: transform 0.5s;
    }
    .shouhou-title{
      font-size: 14px;
      margin-left: 10px;
      color: #999999;
    }
  }
}
.beian{
  background: #141414;
  width: 100%;
  color: #fff;
  text-align: center;
  padding: 10px;
  line-height: 22px;
  font-size: 14px;
}
.shouhou-icon-hover {
  animation: move 0.2s linear forwards;
  transform: rotateY(180deg);
}
@keyframes move {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(90deg);
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
